import { Component, Input } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { ExamService } from "src/app/services/exam.service";
import { EventsHubService, ExamMessage, EXAMMESSAGETYPE } from "src/app/services/eventshub.service";
import { ServerResourcesPathPipe } from "src/app/pipe/serverresourcespath.pipe";
import { PageObjectSelection } from "src/app/models/pageobjectselection";
import { LibraryImage } from "src/app/models/libraryimage";
import { Exam } from "src/app/models/exam";

@Component({
  selector: "hkt-pageobjectselection",
  templateUrl: "./pageobjectselection.component.html",
  styleUrls: ["./pageobjectselection.component.scss"],
})
export class PageObjectSelectionComponent {
  @Input("obj") obj: PageObjectSelection;
  @Input("mode") mode: string;

  exam: Exam;
  examSubscription: Subscription;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
    private serverResourcesPathPipe: ServerResourcesPathPipe,
  ) {}

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
  }

  getSourceUrl(): string {
    let image: LibraryImage = null;
    if (this.obj.selected) {
      if (this.obj.imageSelect) {
        image = this.exam.library.getImage(this.obj.imageSelect);
      } else {
        let defaultImage = this.exam.style ? this.exam.style + "-selection-on.png" : "selection-on.png";
        return "url('assets/" + defaultImage + "')";
      }
    } else {
      if (this.obj.imageNormal) {
        image = this.exam.library.getImage(this.obj.imageNormal);
      } else {
        let defaultImage = this.exam.style ? this.exam.style + "-selection-off.png" : "selection-off.png";
        return "url('assets/" + defaultImage + "')";
      }
    }

    let ret = "";
    if (image == null) {
      ret = "url('assets/notimage.png')";
    } else {
      ret = this.serverResourcesPathPipe.transform(image.source, Config.SERVER_UPLOADFOLDER, "background_url");
    }

    return ret;
  }

  onClick(): void {
    if (this.mode != "exam") {
      return;
    }
    let msg = new ExamMessage();
    msg.type = EXAMMESSAGETYPE.RunAction;
    msg.data = "Deselect(" + this.obj.groupName + ");Select(" + this.obj.groupName + ", " + this.obj.name + ")";
    this.eventsHubService.setExamMessage(msg);
  }
}
